class ScreenSize {
	install(Vue) {
		// Create observable to store screen
		this.screen = Vue.observable({
			width: window.innerWidth,
			height: window.innerHeight
		})

		// Bind screen size to prototype, and bind resize listener
		Vue.prototype.$screen = this.screen
		window.addEventListener('resize', this.onResize.bind(this))

		// Trigger initial resize event
		this.onResize()
	}

	onResize() {
		// Update screen width and height
		this.screen.width = window.innerWidth
		this.screen.height = window.innerHeight
	}
}

export default new ScreenSize()
